import { Flex, Switch, useColorMode, useColorModeValue } from '@chakra-ui/react'
import React from 'react'

export const HeaderAdmin: React.FC = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const bgColor = useColorModeValue('gray.800', 'gray.900');

  return (
    <Flex
      bg={bgColor}
      px={6}
      py={4}
      justify="flex-end"
      align="center"
      position="sticky"
      top={0}
      zIndex={5}
      shadow="sm"
    >
      <Switch colorScheme="teal" isChecked={colorMode === 'dark'} onChange={toggleColorMode} />
    </Flex>
  );
};
